<!-- <ng-container *ngIf="productListService.countDetails$|async as facetData"> -->
<!--  <ng-container *ngIf="this.facetTabIndex==0">
<ng-container *ngIf="facetData?.productModel">
  <ng-container *ngIf="facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0">
    <div class="facet-outer">
      <div id="cx-active-facets-groupName" class="facetActiveheading"
        *ngIf="facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0">
        {{'common.search_nav_applied_facets_emea'|cxTranslate}}
      </div>

      <a *ngFor="let facet of facetData?.productModel?.breadcrumbs" routerLink="./"
        (click)="FacetClick(facet, facetData?.productModel)"
        [cxFocus]="{ key: getFocusKey(facetData?.productModel, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
            'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
          ">
        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    </div>
  </ng-container>
</ng-container>
</ng-container> -->

<!-- Active facet for other tabs -->

<!--  <ng-container *ngIf="this.facetTabIndex==1">
<ng-container *ngIf="facetData?.crossRefModel">
  <ng-container *ngIf="facetData?.crossRefModel.breadcrumbs && facetData?.crossRefModel.breadcrumbs.length > 0">
    <div class="facet-outer" *ngIf="facetData?.crossRefModel.breadcrumbs">
      <div id="cx-active-facets-groupName" class="facetActiveheading"
        *ngIf="facetData?.crossRefModel.breadcrumbs && facetData?.crossRefModel.breadcrumbs.length > 0">
        {{'common.search_nav_applied_facets_emea'|cxTranslate}}
      </div>


      <a *ngFor="let facet of facetData?.crossRefModel?.breadcrumbs" routerLink="./" (click)="FacetClick(facet)"
        [cxFocus]="{ key: getFocusKey(facetData?.crossRefModel, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
            'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
          ">

        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    </div>
  </ng-container>
</ng-container>
</ng-container> -->
<!--  <ng-container *ngIf="this.facetTabIndex==2">
<ng-container *ngIf="facetData?.docModel">
  <ng-container *ngIf="facetData?.docModel?.breadcrumbs && facetData?.docModel?.breadcrumbs.length > 0">
    <div class="facet-outer" *ngIf="facetData?.docModel?.breadcrumbs">
      <div id="cx-active-facets-groupName" class="facetActiveheading"
        *ngIf="facetData?.docModel?.breadcrumbs && facetData?.docModel?.breadcrumbs.length > 0">
        {{'common.search_nav_applied_facets_emea'|cxTranslate}}
      </div>


      <a *ngFor="let facet of facetData?.docModel?.breadcrumbs" routerLink="./" (click)="FacetClick(facet)"
        [cxFocus]="{ key: getFocusKey(facetData?.docModel, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
            'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
          ">

        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    </div>
  </ng-container>
</ng-container>
</ng-container>
<ng-container *ngIf="this.facetTabIndex==4">
  <ng-container *ngIf="facetData?.trainingModel">
    <ng-container *ngIf="facetData?.trainingModel.breadcrumbs && facetData?.trainingModel.breadcrumbs.length > 0">
      <div class="facet-outer" *ngIf="facetData?.trainingModel.breadcrumbs">
        <div id="cx-active-facets-groupName" class="facetActiveheading"
          *ngIf="facetData?.trainingModel.breadcrumbs && facetData?.trainingModel.breadcrumbs.length > 0">
          {{'common.search_nav_applied_facets_emea'|cxTranslate}}
        </div>


        <a *ngFor="let facet of facetData?.trainingModel?.breadcrumbs" routerLink="./" (click)="FacetClick(facet)"
          [cxFocus]="{ key: getFocusKey(facetData?.trainingModel, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
            'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
          ">

          <span>{{ facet.facetValueName }}</span>
          <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.facetTabIndex==3">
  <ng-container *ngIf="facetData?.softwareModel">
    <ng-container *ngIf="facetData?.softwareModel?.breadcrumbs && facetData?.softwareModel?.breadcrumbs.length > 0">
      <div class="facet-outer" *ngIf="facetData?.softwareModel?.breadcrumbs">
        <div id="cx-active-facets-groupName" class="facetActiveheading"
          *ngIf="facetData?.softwareModel?.breadcrumbs && facetData?.softwareModel?.breadcrumbs.length > 0">
          {{'common.search_nav_applied_facets'|cxTranslate}}
        </div>


        <a *ngFor="let facet of facetData?.softwareModel?.breadcrumbs" routerLink="./" (click)="FacetClick(facet)"
          [cxFocus]="{ key: getFocusKey(facetData?.softwareModel, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
            'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
          ">

          <span>{{ facet.facetValueName }}</span>
          <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
</ng-container> -->
<!-- seperateDocDetails -->
@if (this.facetTabIndex==7) {
  @if (productListService.seperateDocDetails$|async; as facetData) {
    <!-- <p>{{facetData?.breadcrumbs.length > 0|json}}</p> -->
    @if (facetData?.breadcrumbs && facetData?.breadcrumbs?.length??0 > 0) {
      @if (facetData?.breadcrumbs) {
        <div class="facet-outer">
          @if (facetData?.breadcrumbs && facetData?.breadcrumbs?.length??0 > 0) {
            <div id="cx-active-facets-groupName" class="facetActiveheading"
              >
              Applied Filters
            </div>
          }
          @for (facet of facetData?.breadcrumbs; track facet) {
            <a routerLink="./" (click)="FacetClick(facet)"
              [cxFocus]="{ key: getFocusKey({facets:facetData.facets || []}, facet) }" role="button"
          (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }">
              <span>{{ facet.facetValueName }}</span>
              <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
            </a>
          }
        </div>
      }
    }
  }
}
<!-- seperateDocDetails Ends -->

<!-- seperateSoftwareDetails -->
<!-- <ng-container *ngIf="this.facetTabIndex==8">
<ng-container *ngIf="productListService.seperateSoftDetails$|async as facetData">
  <p>{{facetData?.breadcrumbs.length > 0|json}}</p>
  <ng-container *ngIf="facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0">
    <div class="facet-outer" *ngIf="facetData?.breadcrumbs">
      <div id="cx-active-facets-groupName" class="facetActiveheading"
        *ngIf="facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0">
        {{'common.search_nav_applied_facets_emea'|cxTranslate}}
      </div>
      <a *ngFor="let facet of facetData?.breadcrumbs" routerLink="./" (click)="FacetClick(facet)"
        [cxFocus]="{ key: getFocusKey(facetData, facet) }" role="button"
        (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }">
        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    </div>
  </ng-container>
</ng-container>
</ng-container> -->
<!-- seperateSoftWareDetails Ends -->